import { getConfig } from '@superbet-group/web.lib.config';
import { Country } from '@superbet-group/web.types';

import { LinkEn } from '@app/router/constants/countryLink/LinkEn';
import { LinkPl } from '@app/router/constants/countryLink/LinkPl';
import { LinkRo } from '@app/router/constants/countryLink/LinkRo';
import { LinkRs } from '@app/router/constants/countryLink/LinkRs';
import { RouteIdentity } from '@app/router/types';
import { LinkPt } from './countryLink/LinkPt';

const CountryLink: Record<Country, RouteIdentity<string>> = {
    [Country.BrSocial]: LinkPt,
    [Country.Br]: LinkPt,
    [Country.Ro]: LinkRo,
    [Country.RoNapoleon]: LinkRo,
    [Country.Pl]: LinkPl,
    [Country.Rs]: LinkRs,
    [Country.Com]: LinkEn,
    [Country.Be]: LinkEn,
    [Country.Bg]: LinkEn,
};

export const Link = CountryLink[getConfig().countrySpecific.country];
